import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faDownload } from '@fortawesome/pro-light-svg-icons';

export const openPdfIcon = faArrowUpRightFromSquare;
export const downloadPdfIcon = faDownload;

export interface IPdfActionCallbacks {
  onOpen: () => void;
  onDownload: () => void;
}

interface IPdfActionButtonsProps {
  disabled?: boolean;
  variant?: ButtonProps['variant'];
  onOpen: () => void;
  onDownload: () => void;
}

export function PdfActionButtons({ disabled, variant = 'outlined', onOpen, onDownload }: Readonly<IPdfActionButtonsProps>) {
  return (
    <>
      <Button variant={variant} disabled={disabled} startIcon={<FontAwesomeIcon icon={openPdfIcon} />} title="Åbn PDF i ny fane" onClick={onOpen}>
        Åbn PDF
      </Button>
      <Button variant={variant} disabled={disabled} startIcon={<FontAwesomeIcon icon={downloadPdfIcon} />} title="Download PDF" onClick={onDownload}>
        Download PDF
      </Button>
    </>
  );
}
